import http from 'src/app/http';
import environment from 'src/app/environment';


const registerUser = (body) => http.post('/users', { ...body });

const sendActivationEmail = (userId) => http.put('/confirmation-email', { userId });

const facebookRegistration = (params) =>
  `${environment.facebookAuthenticationDomain}/zarejestruj-facebook?provider=Facebook&${params}`;

const navigateToNextStep = (origin) => http.get(`/registrationPaths?emailOriginId=${origin}`);

const sendExperienceForm = (body, userId) =>
  http.post(`/users/${userId}/profile/survey`, { ...body }, { headers: { 'Source-Name': 'Pracuj' } });

export default {
  registerUser,
  sendActivationEmail,
  navigateToNextStep,
  facebookRegistration,
  sendExperienceForm
};
